import { Typography, Paper, Box } from "@mui/material";

const IContainer = ({ header, children }) => (
  <Paper elevation={2} sx={{ padding: 2, mb: 2 }}>
    {header && (
      <Typography variant="h6" sx={{ color: "#0550d5", fontWeight: 600, mb: 1.5 }}>
        {header}
      </Typography>
    )}
    <Box sx={{ p: 1 }}>{children}</Box>
  </Paper>
);

export default IContainer;
